import { render, staticRenderFns } from "./ModalPageSettingsContainer.vue?vue&type=template&id=18daaa4e&scoped=true&"
import script from "./ModalPageSettingsContainer.vue?vue&type=script&lang=ts&"
export * from "./ModalPageSettingsContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18daaa4e",
  null
  
)

export default component.exports